export default __webpack_public_path__ + "static/media/16.aa023e71.svg";